import { ProgressIndicator } from '@dnb/eufemia';
import type { JSX } from 'react';

import style from './index.module.css';

export default function CenteredProgressIndicator(): JSX.Element {
  return (
    <div className={style['ProgressPosition']}>
      <ProgressIndicator label="Loading..." labelDirection="vertical" showDefaultLabel size="large" type="circular" />
    </div>
  );
}
